<div class="row" *ngIf="!hasLoadedShop">
  <div class="col-12">
    <p class="alert alert-warning">
      <app-spin-icon></app-spin-icon> Loading Shop...</p>
  </div>
</div>
<div class="row" *ngIf="hasLoadedShop">
  <div class="col-12">
    <div class="row mb-3">
      <h1 class="col-8 h1-responsive m-0">Shop</h1>
      <hr />
    </div>
    <div class="row">
      <div class="card card-cascade wider col mb-5">
        <div class="view gradient-card-header primary-gradient white-text">
          <h3 class='h3-responsive text-center text-truncate'>Package Deals</h3>
        </div>
        <div class="card-body">
          <table class="table table-striped">
            <thead class="secondary-color white-text">
              <tr>
                <th w="50">Package</th>
                <th>Price</th>
                <th w="25">Quantity</th>
              </tr>
            </thead>
            <tbody>
              <tr class="items-list" *ngFor="let item of groupItems">
                <td>
                  {{item.name}}
                  <ul *ngIf="item.subItems?.length">
                    <li *ngFor="let subItem of item.subItems">{{subItem.name}}</li>
                  </ul>
                </td>
                <td>${{item.price}}</td>
                <td>
                  <select class="form-control browser-default" [(ngModel)]="item.quantity">
                    <option *ngFor="let item of [0, 1,2,3,4,5,10,15,20,25,50]">{{item}}</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="card card-cascade wider col">
        <div class="view gradient-card-header primary-gradient white-text">
          <h3 class='h3-responsive text-center text-truncate'>Individual Assessments</h3>
        </div>
        <div class="card-body">
          <table class="table table-striped">
            <thead class="secondary-color white-text">
              <tr>
                <th w="50">Assessment</th>
                <th>Price</th>
                <th w="25">Quantity</th>
              </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of items">
                    <td>{{item.name}}
                      <ul *ngIf="item.subItems?.length">
                        <li *ngFor="let subItem of item.subItems">{{subItem.name}}</li>
                      </ul>
                    </td>
                    <td>${{item.price}}</td>
                    <td><select class="form-control browser-default" [(ngModel)]="item.quantity">
                        <option *ngFor="let item of [0, 1,2,3,4,5,10,15,20,25,50]">{{item}}</option>
                      </select>
                    </td>
                  </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row w-100 shoppingActionBar border bg-light">
      <cart-widget class="col-sm-5 col-md-6"></cart-widget>
      <div class="col-sm-7 col-md-6">
        <input type="button" class="btn btn-secondary" value="Add to Cart" (click)="addItemsToCart()" />
        <input type="button" class="btn btn-primary" value="Checkout" (click)="checkout()" />
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/shop-items/shop-items.component.html